import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import questions from '../../survey/questions';
import steps from '../../survey/steps';
import store from '../../store';
import s from './index.module.scss';
import common from '../index.module.scss';

function validateEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function StepTitle({ userGoal }) {
	const { T } = useT();
	const goal = userGoal ? T(`goal_${userGoal}`) : T('achieve_your_goals');
	const configXmas = store.getState().global.xmasConfig;

	return (
		<div>
			{configXmas
				? (
					<span dangerouslySetInnerHTML={{ __html: T('email_title_V3') }}></span>
				)
				: (
					<span>
						{T('email_title_part_1')}
						&nbsp;
						<span className={s.goal}>{goal}</span>
						&nbsp;
						{T('email_title_part_2')}
					</span>
				)}
		</div>
	);
}

function Mail(props) {
	const { T } = useT();
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const currentStep = useSelector((state) => state.steps.currentStep);
	const placeholder = T('email_placeholder');
	const emailWarningShort = T('email_warning_short');
	const emailWarningLong = T('email_warning_long');
	const emailWarning = T('email_warning');
	const [userGoal, setUserGoal] = useState(false);
	const coloredOptionsStartScreen = store.getState().steps.coloredOptionsStartScreen;

	const savedQuestionValues = useSelector((state) => state.questions.savedAnswers.mail);
	const list = useSelector((state) => state.steps.list);

	const savedValue = savedQuestionValues && savedQuestionValues.value;
	const agreeToInboxSavedValue = savedQuestionValues && savedQuestionValues.agreeToInbox;

	const [value, setValue] = useState(savedValue || '');
	const [validationWarning, setValidation] = useState(false);
	const [agreeToInbox, setAgreeToInbox] = useState(agreeToInboxSavedValue || false);

	const tempClass = (classString) => `${props.inputStyle}_${classString}`;

	function validate() {
		if (value && (value.length >= 63)) {
			setValidation(emailWarningLong);
			return;
		}

		if (value && (value.length <= 5)) {
			setValidation(emailWarningShort);
			return;
		}

		if (!validateEmail(value) && value !== '') {
			setValidation(emailWarning);
			return;
		}

		setValidation(validateEmail(value));
	}

	useEffect(() => {
		validate();
	}, [value, currentStep]);

	function onChangeAction(e) {
		setValue(e.target.value);

		questions.setAnswer({
			questionName: 'mail',
			answerName: 'value',
			answerValue: e.target.value
		});

		!agreeToInbox && questions.setAnswer({
			questionName: 'mail',
			answerName: 'agreeToInbox',
			answerValue: e.target.checked
		});
	}

	useEffect(() => {
		const completed = (value !== '' && validationWarning === true);

		steps.setStepStatus({
			stepName: 'mail',
			stepStatus: completed
		});
	}, [value, list, currentStep, validationWarning]);

	useEffect(() => {
		const goal = questions.getAnswers({ questionName: 'goal' })[Object.keys(questions.getAnswers({ questionName: 'goal' }))[0]];
		const coloredGoal = questions.getAnswers({ questionName: 'colored_options_start_screen' })[Object.keys(questions.getAnswers({ questionName: 'colored_options_start_screen' }))[0]];

		if (coloredOptionsStartScreen) {
			setUserGoal((coloredGoal && coloredGoal.value) || false);
		} else {
			setUserGoal((goal && goal.value) || false);
		}
	}, [currentStep]);

	function changeCheckbox(e) {
		setAgreeToInbox(e.target.checked);

		questions.setAnswer({
			questionName: 'mail',
			answerName: 'agreeToInbox',
			answerValue: e.target.checked
		});
	}

	return (
		<div className={`${common.step} ${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<div className={common.stepTitle}>
				<StepTitle userGoal={userGoal} />
			</div>
			<input
				className={s[tempClass('value')]}
				id="mail"
				type="email"
				value={value}
				pattern=".+@globex\.com"
				autoComplete="true"
				placeholder={placeholder}
				onChange={onChangeAction}
				// onFocus={actionOnFocus}
				tabIndex={!isThisCurrentStep ? -1 : ''}
			/>
			{
				validationWarning &&
				(
					<div className={s.warning}>
						{validationWarning}
					</div>
				)
			}
			<div className={s.description}>
				<div>
					<svg className={s.lock} alt="Lock icon" width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M2.00004 8.14836C0.894648 8.152 0 9.14095 0 10.3773V17.7711C0 19.0023 0.897353 20 2.00599 20H11.994C13.1021 20 14 19.0096 14 17.7711V10.3773C14 9.1484 13.1059 8.15132 12 8.14836V5.55497C12 2.48672 9.75587 0 6.99985 0C4.23849 0 1.99974 2.48672 1.99974 5.55497L2.00004 8.14836ZM4.00009 8.14836V5.55632C4.00009 3.71035 5.34343 2.22216 7.00015 2.22216C8.65344 2.22216 10.0002 3.7148 10.0002 5.55632V8.14836H4.00009Z" />
					</svg>
				</div>
				<div className={s.description_text}>
					<span>{T('email_description_part_1')}</span>
					{' '}<a 
						href="https://verv.com/web-privacy-policy/" 
						target="_blank" 
						rel="noreferrer" 
						className={s.description_text_link1}>
						{T('email_description_link_1')}
					</a>{' '}
					<span>{T('email_description_part_2')}</span>
					{' '}<a href="mailto:support@verv.health" className={s.description_text_link2}>{T('email_description_link_2')}</a>
				</div>
			</div>
			<div className={s.checkboxWrapper}>
				<input 
					className={s.inputToHide} 
					type="checkbox" 
					onChange={changeCheckbox} 
					id="agree" 
					checked={agreeToInbox} 
					tabIndex={!isThisCurrentStep ? -1 : ''} />
				<label 
					className={s.checkbox} 
					htmlFor="agree">
					{T('mail_checkbox_text')}
				</label>
			</div>
		</div>
	);
}

export default Mail;
